import { ChatbotMessages } from "@core/domain/models/chatbot-message.model";
import type { ChatbotRepository } from "@core/domain/repositories/chatbot.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { coreTypes } from "@core/root/core-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class ChatbotWeeklyReportUseCase {
    constructor(
        @inject(coreTypes.repositories.ChatbotRepository)
        private readonly chatbotRepository: ChatbotRepository,
    ) {}

    async execute(): Promise<ChatbotMessages> {
        const chatbotReportResult =
            await this.chatbotRepository.getWeeklyReport();

        if (chatbotReportResult.isErr()) {
            ToastManagerRepository.error(chatbotReportResult.error.message);
        }

        return chatbotReportResult.match(
            (chatbotReport) => chatbotReport,
            () => ChatbotMessages.empty(),
        );
    }
}
